import ApiClient from "api/index";

export default function useClient() {
  const api = new ApiClient();
  return { api };
}